import {Typography} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React, {useCallback} from 'react'

import {FeedbackReason} from 'src/api/types'

import {classes} from './TagReason.styles'

type Props = {
  data: FeedbackReason
  selected: boolean
  onClick: Function
}

const TagReason: React.FC<Props> = ({data, onClick, selected = false}) => {
  const {reason_id: id, title} = data
  const handleReasonClick = useCallback(() => onClick(id), [id, onClick])

  return (
    <Typography
      className={clsx(classes.root, selected && classes.selected)}
      Component="div"
      data-e2e={id}
      onClick={handleReasonClick}
      variant="body2"
    >
      {title}
    </Typography>
  )
}

export default TagReason
